import { z } from 'zod';

export const MultiClientConfigKeySchema = z.enum(['payersciences', 'demo', 'nestle', 'sanofi']);
export type MultiClientConfigKey = z.infer<typeof MultiClientConfigKeySchema>;

export const MultiClientConfigKeyForGptSchema = z.enum(['payersciences', 'demo']);
export type MultiClientConfigKeyForGpt = z.infer<typeof MultiClientConfigKeyForGptSchema>;
